import {
  SET_STATISTICS_DATA,
  SET_SELECTED_STATISTICS_MODEL,
  CLEAR_STATISTICS_DATA,
} from "./mutations";

const initialState = {
  statisticsData: {},
  selectedStatisticsData: {},
  selectedModel: null,
};

const bvaStatisticsToolReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_STATISTICS_DATA: {
      return {
        ...state,
        statisticsData: {
          ...payload,
        },
      };
    }
    case SET_SELECTED_STATISTICS_MODEL: {
      return {
        ...state,
        selectedStatisticsData: {
          ...payload.data
        },
        selectedModel: payload.model
      };
    }
    case CLEAR_STATISTICS_DATA: {
      return {...initialState};
    }
    default:
      return state;
  }
};

export default bvaStatisticsToolReducer;